import { BaseSidePanel } from 'components/sidePanel';
import { ITabItem } from 'components/tab';
import React, { useContext, useEffect, useMemo } from 'react';
import NavigatorThumbnail from './NavigatorThumbnail';
import { useRMDispatch } from 'redux/hooks';
import { useFetchNavigatorImages } from './hooks';
import {
  useLastSelectedDropImageParameters,
  useLastSelectedWellNavigationDetails,
} from 'redux/hooks/experiment';
import {
  DisplayModes,
  GetDisplayMode,
  GetNavigatorStatus,
  isDropWellCompare,
} from 'utils/Global';
import CanvasMap from './CanvasMap';
import { ExpDashboardContext } from 'components/main/ExperimentDashboardContext';
interface NavigatorProps {
  exp;
  changeThTabIndex;
  thTabIndex;
  setMoveToCanvas;
  roi;
  inspTRs;
  dcrTRs;
}

const NavigatorSidePanel = (props: NavigatorProps) => {
  const { exp, changeThTabIndex, thTabIndex, setMoveToCanvas, roi, inspTRs, dcrTRs } =
    props;

  const dispatch = useRMDispatch();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const wellImagingParameterDetails = useLastSelectedDropImageParameters();
  const expDashboardContext = useContext(ExpDashboardContext);
  const { navigatorVerticalPrefetchingCount, navigatorHorizontalPrefetchingCount } =
    expDashboardContext;
  const fetchNav = useFetchNavigatorImages(
    navigatorVerticalPrefetchingCount,
    navigatorHorizontalPrefetchingCount,
  );
  const displayMode = GetDisplayMode();
  const isNavActive = GetNavigatorStatus();
  const isDropWellCompareMode = isDropWellCompare();

  useEffect(() => {
    if (
      isNavActive &&
      (displayMode == DisplayModes.IMAGE ||
        displayMode == DisplayModes.WELLIMAGE ||
        displayMode == DisplayModes.SCORE)
    ) {
      fetchNav(exp, wellNavigationDetails, wellImagingParameterDetails, dispatch);
    }
  }, [displayMode, isNavActive, wellNavigationDetails, wellImagingParameterDetails]);

  const selectedPlate = useMemo(
    () =>
      exp.plateDto.find((plate) => plate.plateNumber === wellNavigationDetails?.plateNum),
    [wellNavigationDetails?.plateNum],
  );

  const tabItems_: ITabItem[] = [
    {
      content: (
        <NavigatorThumbnail
          expId={exp?.experimentId}
          changeThTabIndex={changeThTabIndex}
          thTabIndex={thTabIndex}
          setMoveToCanvas={setMoveToCanvas}
          roi={roi}
          wellNavigationDetails={wellNavigationDetails}
          dropImageParameters={wellImagingParameterDetails}
        />
      ),
      id: 'navigatorsidepanel-tab-thumbnail',
      title: 'Thumbnail Navigator',
      iconProps: {
        id: 'navigatorsidepanel-tab-thumbnail-iconprops',
        name: 'ThumbnailNavigator',
      },
    },
    {
      content: (
        <div id="navigatorsidepanel-wrapper" style={{ height: '76vh', overflow: 'auto' }}>
          <div
            id="navigatorsidepanel-sidecontainer"
            style={{ alignItems: 'end', height: '100%', margin: 0 }}
            className="row"
          >
            <table id={`navigatorsidepanel-sidetable-${dcrTRs}`} className="sideTable1">
              <tbody
                id="navigatorsidepanel-sidetable-body"
                style={{ position: 'sticky', bottom: 0 }}
              >
                {inspTRs}
              </tbody>
              <tfoot
                id="navigatorsidepanel-sidetable-footer"
                style={{ position: 'sticky', bottom: 0, backgroundColor: '#eee' }}
              >
                {dcrTRs}
              </tfoot>
            </table>
          </div>
        </div>
      ),
      title: 'Composite Navigator',
      iconProps: { name: 'CompositeNavigator' },
    },
    ...(isDropWellCompareMode
      ? ([
          {
            content: (
              <CanvasMap
                plateNumber={wellNavigationDetails?.plateNum}
                plateBarcode={selectedPlate?.barCode}
                plateRows={selectedPlate?.rows}
                plateColumns={selectedPlate?.cols}
              />
            ),
            title: 'Canvas Map',
            iconProps: { name: 'CanvasMap' },
          },
        ] as ITabItem[])
      : []),
  ];
  return <BaseSidePanel tabItems={tabItems_} headerTitle={'Navigator'} defaultTab={0} />;
};

export default NavigatorSidePanel;
